import { Forms } from "../../interfaces/forms";

const mainForm: Forms = {
    formHeader: "הוספת מוצר",
    data: [
        {
            name: "firstName",
            label: "שם פרטי",
            fieldType: "text",
            placeholder: "שם פרטי"
        },
        {
            name: "lastName",
            label: "שם משפחה",
            fieldType: "text",
            placeholder: "שם משפחה"
        },
        {
            name: "cellPhone",
            label: "טלפון",
            fieldType: "text",
            placeholder: "טלפון"
        },
        {
            name: "email",
            label: "אימייל",
            fieldType: "text",
            placeholder: "אימייל"
        },
        {
            name: "identityId",
            label: "מספר זהות",
            fieldType: "text",
            placeholder: "מספר זהות"
        }
    ]
}
export default mainForm;
